import {
  AppModules,
  LorenPrivilegeEntityType,
  LorenRole,
  LorenRoleFormViewModel,
} from "../interfaces/loren-role.interface";

export const transformDtoToFormModel = (
  dto: LorenRole
): LorenRoleFormViewModel => {
  return {
    id: dto.id,
    name: dto.name,
    readonly: dto.readOnly,
    entityPrivileges: dto.privileges
      .sort((a, b) => a.length - b.length)
      .map((x) => {
        let entity: AppModules;
        let access: "READ" | "READ_WRITE";

        switch (x) {
          case LorenPrivilegeEntityType.READ_ROLE:
            entity = AppModules.ROLE;
            access = "READ";
            break;
          case LorenPrivilegeEntityType.READ_ASSET:
            entity = AppModules.ASSET;
            access = "READ";
            break;
          case LorenPrivilegeEntityType.READ_AUTOMATION_RULES:
            entity = AppModules.AUTOMATION_RULES;
            access = "READ";
            break;
          case LorenPrivilegeEntityType.READ_GEOFENCE_ZONES:
            entity = AppModules.GEOFENCE_ZONES;
            access = "READ";
            break;
          case LorenPrivilegeEntityType.READ_GROUPS:
            entity = AppModules.GROUPS;
            access = "READ";
            break;
          case LorenPrivilegeEntityType.WRITE_ASSET:
            entity = AppModules.ASSET;
            access = "READ_WRITE";
            break;
          case LorenPrivilegeEntityType.WRITE_AUTOMATION_RULES:
            entity = AppModules.AUTOMATION_RULES;
            access = "READ_WRITE";
            break;
          case LorenPrivilegeEntityType.WRITE_GEOFENCE_ZONES:
            entity = AppModules.GEOFENCE_ZONES;
            access = "READ_WRITE";
            break;
          case LorenPrivilegeEntityType.WRITE_GROUPS:
            entity = AppModules.GROUPS;
            access = "READ_WRITE";
            break;
          case LorenPrivilegeEntityType.WRITE_ROLE:
            entity = AppModules.ROLE;
            access = "READ_WRITE";
            break;
        }

        return {
          entity,
          access,
        };
      }),
  };
};

export const transformFormModelToDto = (
  model: LorenRoleFormViewModel
): LorenRole => {
  return {
    id: model.id,
    name: model.name,
    privileges: model.entityPrivileges.map((x) => {
      switch (x.entity) {
        case AppModules.ASSET:
          return x.access === "READ"
            ? LorenPrivilegeEntityType.READ_ASSET
            : LorenPrivilegeEntityType.WRITE_ASSET;
        case AppModules.AUTOMATION_RULES:
                   return x.access === "READ"
            ? LorenPrivilegeEntityType.READ_AUTOMATION_RULES
            : LorenPrivilegeEntityType.WRITE_AUTOMATION_RULES;
        case AppModules.GEOFENCE_ZONES:
                   return x.access === "READ"
            ? LorenPrivilegeEntityType.READ_GEOFENCE_ZONES
            : LorenPrivilegeEntityType.WRITE_GEOFENCE_ZONES;
        case AppModules.GROUPS:
          return x.access === "READ"
            ? LorenPrivilegeEntityType.READ_GROUPS
            : LorenPrivilegeEntityType.WRITE_GROUPS;
        case AppModules.ROLE:
          return x.access === "READ"
            ? LorenPrivilegeEntityType.READ_ROLE
            : LorenPrivilegeEntityType.WRITE_ROLE;
      }
    }),
    readOnly: model.readonly,
  };
};
